import { render, staticRenderFns } from "./bankClassification.vue?vue&type=template&id=8d99aa90"
import script from "./bankClassification.vue?vue&type=script&lang=js"
export * from "./bankClassification.vue?vue&type=script&lang=js"
import style0 from "./bankClassification.vue?vue&type=style&index=0&id=8d99aa90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports